import React, { Component, Fragment } from 'react';
import { computed, observable } from 'mobx';
import { Observer } from 'mobx-react';
import _ from 'lodash';

import {
  PrimaryButton,
  DefaultButton,
} from 'office-ui-fabric-react/lib/Button';

import { FooterContainer } from 'components/PanelFooter';

import { Spinner, SpinnerSize } from 'office-ui-fabric-react/lib/Spinner';

/*

props.onClose()

*/

class BulkRegistrationPanelBase extends Component {
  store = null; // BulkRegistrationStore()

  @observable editing = false;

  handleClose = () => {
    this.store.abort();
    const { onClose } = this.props;
    if (onClose) onClose();
  };

  handleSave = async () => {
    const { onClose } = this.props;
    await this.store.save();
    // if nothing's left -> close the panel
    if (!_.find(this.store.items, (item) => !this.store.isItemEmpty(item))) {
      if (onClose) onClose(); // only if there's no item left
    }
  };

  @computed get canSave() {
    return this.editing && !this.store.saving && this.store.validItemsCount > 0;
  }

  renderRegistrationResult = () => {
    if (!this.store) {
      return null;
    }
    const { t } = this.props;
    const { successfulRegistrations, failedRegistrations } = this.store;
    return (
      <div style={{ display: 'flex', gap: '5px' }}>
        <Fragment>
          {failedRegistrations.length > 0 && (
            <div
              style={{
                backgroundColor: this.store.itemColorMap['invalid'],
                padding: '5px',
                marginRight: 0,
              }}
            >
              {t('failed_registrations', {
                count: failedRegistrations.length,
              })}
            </div>
          )}
          {successfulRegistrations.length > 0 && (
            <div
              style={{
                backgroundColor: this.store.itemColorMap['valid'],
                padding: '5px',
                marginLeft: 0,
              }}
            >
              {t('successful_registrations', {
                count: successfulRegistrations.length,
              })}
            </div>
          )}
        </Fragment>
      </div>
    );
  };

  renderPanelFooterContentAdditional = () => null;

  renderPanelFooterContent = () => {
    const { t } = this.props;
    const successfulRegistrations =
      this.store &&
      this.store.successfulRegistrations.length > 0 &&
      this.store.failedRegistrations.length === 0;

    return (
      <Observer
        render={() => (
          <FooterContainer>
            {this.editing && (
              <Fragment>
                <div
                  style={{
                    display: 'flex',
                    marginRight: 'auto',
                    fontSize: 'small',
                    flexDirection: 'column',
                  }}
                >
                  <div
                    style={{
                      display: 'flex',
                      fontSize: 'small',
                      alignItems: 'center',
                    }}
                  >
                    {_.filter(
                      this.store.columns,
                      (column) => column.footnote
                    ).map((column) => (
                      <span
                        key={column.footnote_index}
                        style={{
                          marginLeft: column.footnote_index > 1 ? '8px' : '0',
                        }}
                      >
                        {column.footnote_index}) {column.footnote}
                      </span>
                    ))}
                  </div>
                  <div
                    style={{
                      display: 'flex',
                      alignItems: 'center',
                    }}
                  >
                    <div
                      style={{
                        backgroundColor: this.store.itemColorMap['valid'],
                        padding: '5px',
                        margin: '5px',
                        marginLeft: 0,
                      }}
                    >
                      {t('valid_description')}
                    </div>
                    <div
                      style={{
                        backgroundColor: this.store.itemColorMap['duplicate'],
                        padding: '5px',
                        margin: '5px',
                      }}
                    >
                      {t('duplicate_description')}
                    </div>
                    <div
                      style={{
                        backgroundColor: this.store.itemColorMap['invalid'],
                        padding: '5px',
                        margin: '5px',
                        marginRight: 0,
                      }}
                    >
                      {t('invalid_description')}
                    </div>
                  </div>
                </div>
              </Fragment>
            )}
            {this.renderPanelFooterContentAdditional()}

            {successfulRegistrations ? (
              <Fragment>
                <DefaultButton
                  onClick={this.handleSave}
                  style={{ marginRight: '8px', alignSelf: 'flex-end' }}
                  disabled={!this.canSave}
                >
                  {this.store.saving
                    ? `${t('Registering')}...`
                    : t('Register') + ` (${this.store.validItemsCount})`}
                  {this.store.saving && (
                    <Spinner
                      size={SpinnerSize.xSmall}
                      style={{ paddingLeft: '10px' }}
                    />
                  )}
                </DefaultButton>
                <PrimaryButton
                  onClick={this.handleClose}
                  style={{ alignSelf: 'flex-end' }}
                >
                  {t('Close')}
                </PrimaryButton>
              </Fragment>
            ) : (
              <Fragment>
                <PrimaryButton
                  onClick={this.handleSave}
                  style={{ marginRight: '8px', alignSelf: 'flex-end' }}
                  disabled={!this.canSave}
                >
                  {this.store.saving
                    ? `${t('Registering')}...`
                    : t('Register') + ` (${this.store.validItemsCount})`}
                  {this.store.saving && (
                    <Spinner
                      size={SpinnerSize.xSmall}
                      style={{ paddingLeft: '10px' }}
                    />
                  )}
                </PrimaryButton>
                <DefaultButton
                  onClick={this.handleClose}
                  style={{ alignSelf: 'flex-end' }}
                >
                  {t('Cancel')}
                </DefaultButton>
              </Fragment>
            )}
          </FooterContainer>
        )}
      />
    );
  };
}

export default BulkRegistrationPanelBase;



// WEBPACK FOOTER //
// ./src/app/containers/Sale/OffersSection/BulkRegistration/BulkRegistrationPanelBase.jsx